import { render, staticRenderFns } from "./PayinTransDetails.vue?vue&type=template&id=229b7275&scoped=true"
import script from "./PayinTransDetails.vue?vue&type=script&lang=js"
export * from "./PayinTransDetails.vue?vue&type=script&lang=js"
import style0 from "./PayinTransDetails.vue?vue&type=style&index=0&id=229b7275&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229b7275",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('229b7275')) {
      api.createRecord('229b7275', component.options)
    } else {
      api.reload('229b7275', component.options)
    }
    module.hot.accept("./PayinTransDetails.vue?vue&type=template&id=229b7275&scoped=true", function () {
      api.rerender('229b7275', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data-agent/components/PayinTransDetails.vue"
export default component.exports